import { render, staticRenderFns } from "./WidgetObjectiveWeights.vue?vue&type=template&id=407166a9&scoped=true&"
import script from "./WidgetObjectiveWeights.vue?vue&type=script&lang=js&"
export * from "./WidgetObjectiveWeights.vue?vue&type=script&lang=js&"
import style0 from "./WidgetObjectiveWeights.vue?vue&type=style&index=0&id=407166a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407166a9",
  null
  
)

export default component.exports